import React from 'react';
import './ActionIconButton.css';

function ActionIconButton({ icon: Icon, onClick, disabled = false, tooltip, bgColor, tooltipPosition = 'left' }) {
  const wrapperStyle = bgColor ? { '--color-button-action': bgColor } : undefined;
  return (
     <div className={`action-icon-button-wrapper tooltip-${tooltipPosition}`}>
      <button
        className="action-icon-button"
        style={wrapperStyle}
        onClick={onClick}
        disabled={disabled}
      >
        {Icon && <Icon className="action-icon-button-icon" />}
      </button>
      {tooltip && <div className="action-icon-tooltip">{tooltip}</div>}
    </div>
  );
}

export default ActionIconButton;